<template>
  <div>
    Edit Outbound Consultation
  </div>
</template>

<script>
export default {
  name: 'Window.Consultation.Outbound.Edit'
}
</script>

<style scoped>

</style>
